module.exports = __webpack_public_path__ + "static/logo-footer-64e3f7295e78ec12eda51fa4c6c923e4.png";